import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Input } from "antd";
import { ReactComponent as PlusGradient } from "../../../../../assets/svgs/plus-gradient.svg";
import { useSelector } from "react-redux";
import { postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import toast from "react-hot-toast";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
const { TextArea } = Input;

const AddNewSubSection = ({
  onOpen,
  onClose,
  sectionId,
  setSubSectionCreated,
}) => {
  const [subSections, setSubSections] = useState("");
  const [errors, setErrors] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const _user = useSelector((state) => state.auth.user);
  const clientId = _user?.client_id?._id || _user?._id;

  const handleClear = () => {
    setSubSections([""]);
    setErrors([]);
    onClose();
  };

  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };

  const createSection = async (subsections, clientId, sectionId) => {
    try {
      const body = {
        customSectionId: sectionId,
        client_id: clientId,
        status: "Active",
        name: subsections,
        description: "This is description",
      };
      const response = await postApi({
        apiUrl: API_URLS.CREATE_SUBSECTIONS,
        data: body,
      });
      if (response.success) {
        setSubSectionCreated(true);
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } },
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <p className="text-[15px] mt-2 mb-1 font-medium">Success!</p>
        //       <h2 className="text-xl font-semibold text-[#000000]">
        //         Section added successfully.
        //       </h2>
        //     </div>
        //   ),
        // });

        triggerPopup("success", "Success", " Sub Section added successfully.");

        setTimeout(() => {
          Modal.destroyAll(); // Close all modals
          // handleSuccessComplete();
          onClose();
        }, 2000);
      }
    } catch (error) {
      console.log("Error in creating new Section", error);
    }
  };

  const handleSave = async () => {
    if (!subSections.trim()) {
      setErrors(true);
      return;
    }

    //setErrors(false);
    await createSection(subSections, clientId, sectionId);
  };

  return (
    <div className="flex justify-center my-4">
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Sub Section </h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <div className="mb-4">
              <p className="text-base font-light px-2">Sub Section *</p>
              <Input
                value={subSections}
                onChange={(e) => {
                  setSubSections(e.target.value);
                  if (errors) setErrors(false); // reset error if previously shown
                }}
                placeholder={`Enter Sub Section`}
                style={{
                  border: "1px solid #ebedf3",
                  borderRadius: "10px",
                  padding: "10px",
                }}
                className="text-base font-light"
              />
              {errors && (
                <p className="text-red-500 text-xs pl-2 mt-2">
                  Please fill out this field.
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleClear}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
        </div>
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </DialogBox>
    </div>
  );
};

export default AddNewSubSection;
